import styled from "@emotion/styled";

export const SuppliersPage = styled.main`
  margin: 80px 0 140px;
  .title {
    font-weight: 500;
    font-size: 20px;
    line-height: 35px;
    color: #000000;
    margin-bottom: 20px;
  }
  .text {
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;
    color: #808285;
  }
  .formWrapper {
    margin: 50px 0 0 0;
    position: relative;
  }

  button {
    padding: 9px 45px;
    border-radius: 74px;
  }

  .MuiInputBase-root {
    margin-bottom: 30px;
  }

  .inputWrapper {
    display: flex;
    justify-content: space-between;
    .inputWrapper {
      flex: 1;
    }
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {},
  })}
`;

export const TenderBox = styled.div`
  background: url(${props => props.bg}) no-repeat center center / cover,
    linear-gradient(180deg, #17479e 0%, #0c2c67 100%);
  border-radius: 15px;
  padding: 30px;
  min-height: 240px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  .title {
    color: #fff;
    margin-bottom: 20px;
    font-weight: 800;
    font-size: 28px;
    line-height: 34px;
  }
  .text {
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    color: #d3daeb;
    margin-bottom: 25px;
  }
  .link {
    background: #ffffff;
    border-radius: 50px;
    font-weight: 600;
    font-size: 18px;
    line-height: 14px;
    color: #17479e;
    padding: 17px 20px;
    display: inline-block;
  }
`;
